import React from 'react';
import ScrollableFeed from 'react-scrollable-feed';
import config from 'config';

export default function(props){

  const banUser = function(userId) {
    swal.fire({
      showCancelButton: true,
      icon: 'warning',
      title: 'Ban User?',
      text: 'Are you sure you want to ban this user?'
    }).then((d) => {
      if (d.value) {
        $.post(config.API_ROOT + '/chat-messages/ban-user', {
          user_id: userId,
          page_section_id: props.pageSectionId
        }).then(() => {
          swal.fire('Banned', 'The user has been banned.', 'success');
        });
      }
    });
  };

  const user = FW.store.get('user');
  return <ScrollableFeed forceScroll={true}>
    {props.messages ? props.messages.map((m, i) => {
      const banUserButton = user && user.may('edit_page', FW.store.get('page')) && m.user_id !== props.user.id ?
        <span className="fa fa-ban" title="Ban User" onClick={banUser.bind(this, m.user_id)}></span> : null;
      const prevMessage = props.messages[i - 1];
      const displayName = !(prevMessage && prevMessage.user_id === m.user_id);
      return <div key={m.id} className={'message ' + (m.user_id === props.user.id ? 'my-message' : 'other-message')}>
        {displayName ? <div className="message-name">{banUserButton} {m.user_name}</div> : null}
        <span className="message-contents">
        {m.message}
      </span>
      </div>
    }) : null}
    {props.messages && props.messages.length === 0 ? <div style={{textAlign: 'center', height: '100%', paddingTop: '48%'}}>
      No one has said anything yet. Start the conversation.
    </div> : null}
  </ScrollableFeed>;
}
